import Swal from "sweetalert2";

export async function confirmClose() {
    const result = await Swal.fire({
        title: $trans('storefront::image_editor.close_image_editor'),
        text: $trans('storefront::image_editor.unsaved_progress_will_be_lost'),
        icon: 'warning',
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: $trans('storefront::image_editor.leave'),
        cancelButtonText: $trans('storefront::image_editor.cancel'),
        customClass: {
            confirmButton: 'btn btn-outline-primary',
            cancelButton: 'btn btn-primary',
            actions: 'gap-4',
            icon: 'd-none',
        }
    })

    if (result.value) {
        handleCloseClick();
    }
}

function handleCloseClick() {
    window.location.href = window.FleetCart.backUrl ?? '/';
}
